import { SubjectModel } from "model";

export const computeInitialSubjectSelected = (
  validList: SubjectModel[],
  initialSelection: string[],
) => {
  const isValid = initialSelection.every((item) =>
    validList.some((subject) => subject.value === item),
  );

  return isValid ? initialSelection : ["Unknown"];
};

export const translateSelectedSubjects = (
  selectedSubjectStrings: string[],
  subjectData: SubjectModel[],
) => {
  const selectedSubjects = selectedSubjectStrings.map((subjectString) => {
    return subjectData.find((subject) => subject.value === subjectString)?.label;
  });
  return selectedSubjects.join(", ");
};
